import { Alert, AlertTitle, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { SelectUserButton } from "./SelectUserButton.js";

export const InvalidSelectedUserError = () => {
  const { t } = useTranslate(["Global"]);

  return (
    <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
      <Alert action={<SelectUserButton />}>
        <AlertTitle>{t("Error", { ns: "Global" })}</AlertTitle>
        {"Selected user does not exist in available users"}
      </Alert>
    </Stack>
  );
};
